import HotelHitContentHeader from './HotelHitContentHeader.js';
import HotelHitContentBody from './HotelHitContentBody.js';
import HotelHitContentFooter from './HotelHitContentFooter.js';
import { HotelHitContentContainer } from './styles/hotelHitContent.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var HotelHitContent = function HotelHitContent(_ref) {
  var _ref$content = _ref.content,
    headerContent = _ref$content.headerContent,
    bodyContent = _ref$content.bodyContent,
    footerContent = _ref$content.footerContent,
    href = _ref.href,
    onSelect = _ref.onSelect,
    buttonHref = _ref.buttonHref,
    onOpenPriceDetails = _ref.onOpenPriceDetails,
    onDistrictClick = _ref.onDistrictClick,
    siteId = _ref.siteId,
    lazy = _ref.lazy;
  return /*#__PURE__*/jsxs(HotelHitContentContainer, {
    children: [headerContent && /*#__PURE__*/jsx(HotelHitContentHeader, {
      headerContent: headerContent,
      href: href,
      onSelect: onSelect,
      onDistrictClick: onDistrictClick,
      siteId: siteId,
      lazy: lazy
    }), bodyContent && /*#__PURE__*/jsx(HotelHitContentBody, {
      bodyContent: bodyContent,
      href: href,
      onSelect: onSelect
    }), footerContent && /*#__PURE__*/jsx(HotelHitContentFooter, {
      footerContent: footerContent,
      onOpenPriceDetails: onOpenPriceDetails,
      href: href,
      onSelect: onSelect,
      buttonHref: buttonHref
    })]
  });
};
HotelHitContent.defaultProps = {
  content: null,
  href: null,
  onSelect: null,
  onOpenPriceDetails: null,
  onDistrictClick: null,
  buttonHref: null,
  siteId: 1,
  lazy: false
};
var HotelHitContent$1 = HotelHitContent;

export { HotelHitContent$1 as default };
//# sourceMappingURL=HotelHitContent.js.map
